import { http } from './http'

export async function registerUser (user: any): Promise<any> {
    return (await http.post('/auth/register', user)).data
}

export async function signInAsUser(user: any): Promise<any> {
    return (await http.post('/auth/login', user)).data
}
